import { render, staticRenderFns } from "./ExtendUpdate.vue?vue&type=template&id=a51c575c&scoped=true"
import script from "./ExtendUpdate.vue?vue&type=script&lang=js"
export * from "./ExtendUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51c575c",
  null
  
)

export default component.exports